var annualReportNavigation = require('../mixins/annual-report-navigation')

module.exports = Em.Controller.extend(annualReportNavigation, {
    year: function() {
        return this.get('model.commitment.year')
    }.property('model.commitment.year')
})
